export default function(eccent, sinphi, cosphi) {
  var con = eccent * sinphi;
  return cosphi / (Math.sqrt(1 - con * con));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/msfnz.js
// module id = 33
// module chunks = 0